import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { RadioWavesIcon } from '../../atoms/icons/radio_waves_icon';
export const SearchFilterDifficulty = ({ items, onClick }) => {
    return (React.createElement("div", { className: css(styles.row) }, items.map((item, index) => (React.createElement("div", { key: item.id, className: css(styles.card, index < items.length - 1 && styles.cardGap, item.selected && styles.cardOn), onClick: () => onClick(item.id) },
        React.createElement(RadioWavesIcon, { difficultyDegree: item.degree, fillColor: Colors.PrimaryDark, emptyColor: Colors.BlueLighterB }),
        React.createElement("span", null, item.name))))));
};
const styles = StyleSheet.create({
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    card: {
        flex: 1,
        minWidth: 0,
        cursor: 'pointer',
        backgroundColor: Colors.White,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0',
        fontSize: 14,
        lineHeight: '140%',
        gap: 2,
    },
    cardGap: {
        marginRight: 8,
    },
    cardOn: {
        borderColor: Colors.PrimaryDark,
        backgroundColor: Colors.PrimaryLighter,
    },
});
